import { useCallback } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { type ScheduleFormValues } from '../../domain/Shipment'
import { type OpenDockWarehouseFormFields } from '../../infra/ShipmentMapper'
import { createOpenDockWarehouseAppointment } from '../../use-cases/createOpenDockWarehouseAppointment'

export function useCreateOpenDockWarehouseAppointment() {
  const { call, result, status, error } = useAsync(createOpenDockWarehouseAppointment)
  const abortController = useAbortController()

  const createAppointment = useCallback(
    (
      shipmentUUID: string,
      stopIndex: number,
      params: {
        staticFields: ScheduleFormValues
        warehouseFormFields: OpenDockWarehouseFormFields
        openDockCarrierId: string | undefined
        facilityTimezone: string
      }
    ) => {
      return call({
        shipmentUUID,
        stopIndex,
        params,
        config: abortController,
      })
    },
    [call, abortController]
  )

  return {
    createAppointment,
    status,
    error,
    result,
  }
}
